const getty = (externalId, credit) => ({
    type: "getty",
    externalId,
    credit,
    license: "Editorial"
});
const officialX = (accountName, accountHandle, externalId, postedAt, text) => ({
    type: "official-social",
    platform: "X",
    accountName,
    accountHandle,
    externalId,
    externalUrl: `https://x.com/${accountHandle}/status/${externalId}`,
    postedAt,
    text
});
export const summerSources = {
    opener: getty("2286091747", "Carmen Mandato"),
    carr: getty("2285558695", "David Becker / NBAE"),
    manon: getty("2285558725", "David Becker / NBAE"),
    kaluma: getty("2285556968", "Tom O'Connor / NBAE"),
    scheduleX: officialX("Los Angeles Lakers", "Lakers", "2077196451667726671", "2026-07-15T01:00:01Z"),
    manonX: officialX("NBA", "NBA", "2077218449625866381", "2026-07-15T02:27:25Z", "Chris Mañon has 10 of LAL's first 13 points!\n\n📺 LAC/LAL I NBA Summer League on Prime https://t.co/zma4r4LfUQ"),
    clippersRallyX: officialX("LA Clippers", "LAClippers", "2077233231204888610", "2026-07-15T03:26:10Z"),
    finalX: officialX("Los Angeles Lakers", "Lakers", "2077244705696542852", "2026-07-15T04:11:45Z", "3-0 in Vegas -- Let's keep it going #LakersWIN https://t.co/EQ2Vs9rtWS")
};
export const finalsSources = {
    wembanyama: getty("2280981198", "Dustin Satloff"),
    winner: getty("2280353181", "Joe Murphy / NBAE"),
    arena: getty("2280994424", "Dustin Satloff"),
    exterior: getty("2280345752", "Mike Lawrence / NBAE"),
    firstQuarterX: officialX("San Antonio Spurs", "spurs", "2064881279967928531", "2026-06-11T01:23:55Z", "BIG FIRST QUARTER FOR THE SQUAD!\n\nEND 1Q | SAS 41, NYK 22 https://t.co/Ika6CuaXfw"),
    townsX: officialX("NEW YORK KNICKS", "nyknicks", "2064909169254391982", "2026-06-11T03:14:44Z", "karl-anthony towns in the fourth quarter 😳 https://t.co/J8CklEG88A"),
    finalX: officialX("NEW YORK KNICKS", "nyknicks", "2064914904339911156", "2026-06-11T03:37:32Z", "THE GREATEST COMEBACK IN NBA PLAYOFF HISTORY. https://t.co/SS1zK81Wxm")
};
export const regularSeasonSources = {
    nembhard: getty("2257304568", "Zach Beeker / NBAE"),
    gilgeousAlexander: getty("2257317295", "Joshua Gateley"),
    gettingReadyX: officialX("OKC THUNDER", "okcthunder", "2014855979242860742", "2026-01-24T00:21:14Z", "Getting ready ⚡️ https://t.co/q7j6Uk4ogk"),
    firstQuarterX: officialX("Indiana Pacers", "Pacers", "2014876797825884484", "2026-01-24T01:43:57Z", "Beautiful play design and T.J. McConnell banks it in from the baseline to beat the first quarter buzzer for tonight's Shot of the Game 🔥 https://t.co/Zvtzy7wJWP"),
    finalX: officialX("Indiana Pacers", "Pacers", "2014905261727637827", "2026-01-24T03:37:04Z", "Leaving OKC with the win 💥\n\n#PacersWin https://t.co/CFGuRtXllv")
};
